module.exports = __webpack_public_path__ + "img/watching-series.225fdc75.svg";